"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.momentize = momentize;
exports.demomentize = demomentize;

var _moment = _interopRequireDefault(require("moment"));

var _datetime = require("@edison/datetime");

var _functools = require("@edison/functools");

/**
 * Helper method that converts datetime values in the object value into Moment
 * objects.
 */
function momentize(keys) {
  return function (o) {
    var toMomentObject = function toMomentObject(timestamp) {
      return (0, _datetime.convertTimestamp)(timestamp);
    };

    return (0, _functools.mapValue)(toMomentObject, new Set(keys))(o);
  };
}
/**
 * Helper method that converts moment values in the object value into unix timestamp.
 */


function demomentize(o) {
  var toTimestamp = function toTimestamp(momentObj) {
    if (!_moment["default"].isMoment(momentObj)) {
      return momentObj;
    }

    return (0, _datetime.convertMoment)(momentObj);
  };

  return (0, _functools.mapValue)(toTimestamp)(o);
}
//# sourceMappingURL=datetime.js.map